import { Geography } from '../../../../../../core/constants/geography';

/**
 * Mask configurations used in the [mask] directive for the latitude longitude fields.
 * Documentation: https://imask.js.org/guide.html
 */
export class LatitudeLongitudeMaskConfig {
    public static readonly latitude = {
        mask: Number,
        scale: 6,
        signed: true,
        thousandsSeparator: '',
        padFractionalZeros: false,
        normalizeZeros: true,
        min: Geography.latitudeUnitedStatesAndTerritoriesMinimum,
        max: Geography.latitudeUnitedStatesAndTerritoriesMaximum,
        radix: '.',
        lazy: false,
    };

    public static readonly longitude = {
        mask: Number,
        scale: 6,
        signed: true,
        thousandsSeparator: '',
        padFractionalZeros: false,
        normalizeZeros: true,
        min: Geography.longitudeUnitedStatesAndTerritoriesMinimum,
        max: Geography.longitudeUnitedStatesAndTerritoriesMaximum,
        radix: '.',
        lazy: false,
    };
}
